import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth.js";

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { session, ready } = useAuth();
  const loc = useLocation();

  if (!ready) {
    return (
      <div className="grid h-screen place-items-center bg-bg text-ink-mute">
        <p className="font-mono text-meta uppercase">caricamento...</p>
      </div>
    );
  }
  if (!session) {
    return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  }
  return <>{children}</>;
}
